import React, { useCallback, useLayoutEffect, useState } from "react";
import { createTheme } from "@mui/material";
import { deepmerge } from "@mui/utils";
import type { Theme } from "@mui/material/styles/createTheme";

import { Config } from "../types/ChatInterfaces";

import {
  baseBotTheme,
  componentStyles,
} from "../utils/styleUtils/customMUIStyles";
import { extractConfig, postMessageToParent } from "../utils";
const setIframeStyle = (_styleConfigs: any) => {
  if (_styleConfigs?.zIndex) {
    postMessageToParent("UI.FRAME_STYLE_UPDATE", {
      style: { zIndex: _styleConfigs?.zIndex },
    });
  }
};

const useV2ChatBotWidget = () => {
  const [themeConfig, setThemeConfig] = useState<Theme | null>(null);
  const [config, setConfig] = useState<Config>(extractConfig as any);
  const [messages, setMessages] = useState([]);
  const updateConfig = (val: Config) => {
    setConfig((prev) => ({ ...prev, ...val }));
  };

  const handleConfigTheme = async (data: any) => {
    const { config, themeConfig, styleConfigs } = data || {};
    const currentLanguage = config?.current_language || "en-US"; // Default to "en-US"
    const supportedLanguages = config?.supported_languages || ["en-US"];
    const translations = config?.translations?.[currentLanguage] || {};
    const customizable_config = translations || {};

    setIframeStyle(styleConfigs);
    setConfig((prev) => ({
      ...prev,
      ...customizable_config,
      supported_languages: supportedLanguages,
      current_language: currentLanguage,
    }));
    const { healthcareTheme: healthcareThemeObj } = await import(
      "@joveo/tao-widgets-v2"
    );

    const healthcareTheme = createTheme(healthcareThemeObj);
    try {
      const themeData = themeConfig?.theme || {};

      const customThemeApi = {
        ...themeData,
        components: componentStyles(),
      };
      setThemeConfig(createTheme(deepmerge(healthcareTheme, customThemeApi)));
    } catch (error) {
      console.error("Error fetching theme:", error);
      setThemeConfig(createTheme(deepmerge(healthcareTheme, baseBotTheme())));
    }
  };
  return {
    themeConfig,
    config,
    updateConfig,
    setThemeConfig,
    setConfig,
    messages,
    handleConfigTheme,
  };
};

export default useV2ChatBotWidget;
